import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AppLoadingService } from './core/services/app-loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'LAMAS-PARTENAIRE';
  loading$: Observable<boolean>;

  constructor(private appLoading: AppLoadingService) {
    this.loading$ = this.appLoading.loading$;
  }
}
